/**
 * A row-scoped service program that appears on the menu but cannot enter any
 * online or voice ordering flow. There is deliberately no tenant-wide default:
 * a row is restricted only when it carries this explicit policy.
 */
export type MenuServicePolicy = {
  kind: "dine_in_program";
  programId: string;
  label: string;
  note: string;
  durationMinutes?: number;
  orderability: "not_orderable";
};

type MenuItemWithServicePolicy = {
  servicePolicy?: Pick<MenuServicePolicy, "orderability">;
};

export const MENU_ITEM_NOT_WEB_ORDERABLE_MESSAGE =
  "This item is available for dine-in only and cannot be ordered online.";

export function isMenuItemWebOrderable(
  item: MenuItemWithServicePolicy,
): boolean {
  // The validator permits only `not_orderable` policy rows. Treat the presence
  // of a policy as a deny so a partially migrated or malformed policy cannot
  // become web-orderable by accident; no policy keeps ordinary menu rows live.
  return item.servicePolicy === undefined;
}

export function assertMenuItemIsWebOrderable(
  item: MenuItemWithServicePolicy,
): void {
  if (!isMenuItemWebOrderable(item)) {
    throw new Error(MENU_ITEM_NOT_WEB_ORDERABLE_MESSAGE);
  }
}
